
import { defineComponent } from "vue";
import Notifications from "../Shared/NotificationsDropdown.vue";

export default defineComponent({
  name: "AppHeader",
  data() {
    return {
      role: "",
      filterByRead: false,
      dropdownIsOpen: false,
    };
  },
  components: {
    Notifications,
  },
  mounted() {
    const dropdowns = Array.from(
      document.getElementsByClassName("dropdown-toggle")
    );
    dropdowns.forEach((dropdown) => {
      const toggler = dropdown as HTMLElement;
      toggler.addEventListener("show.bs.dropdown", () => {
        this.dropdownIsOpen = true;
        toggler.classList.replace("text-white", "text-primary");
      });

      toggler.addEventListener("hide.bs.dropdown", () => {
        this.dropdownIsOpen = false;
        toggler.classList.replace("text-primary", "text-white");
      });
    });
  },
  beforeUnmount() {
    const dropdowns = Array.from(
      document.getElementsByClassName("dropdown-toggle")
    );
    dropdowns.forEach((dropdown) => {
      const toggler = dropdown as HTMLElement;
      toggler.removeEventListener("show.bs.dropdown", () => {
        this.dropdownIsOpen = true;
        toggler.classList.replace("text-white", "text-primary");
      });

      toggler.removeEventListener("hide.bs.dropdown", () => {
        this.dropdownIsOpen = false;
        toggler.classList.replace("text-primary", "text-white");
      });
    });
  },
});
